import { EventEmitter, Injectable } from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class ClientePerfilService {

    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService,
        private _http: HttpClient,
        public utilitesService: UtilitesService) {
    }

    /**
     * View
     * @param id ID
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "perfil-cliente/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Ativo Para Campo Do Cadastro de Cliente
     */
    getLista(): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "perfil-cliente/lista", { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista
     * @param id ID
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "perfil-cliente"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista
     * @param id ID
     */
    search(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "perfil-cliente/search"+env, { headers: this.authService.getAuthHeaders() });
    }    

    /**
     * Delete
     * @param id ID
     */
    delete(id: number): Observable<any> {        
        return this._http.delete(this.utilitesService.urlPrefix + "perfil-cliente/"+id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Cadastra
     * @param params Json
     */
    create(params: any):Observable<any>{
        return this._http.post(this.utilitesService.urlPrefix + "perfil-cliente", JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Atualiza
     * @param params Json
     */
    update(id: number, params: any):Observable<any>{
        return this._http.put(this.utilitesService.urlPrefix + "perfil-cliente/"+id, JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

}